var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-md flex flex-col" }, [
    _c("div", { staticClass: "flex gap-sm items-center grow" }, [
      _c(
        "div",
        { staticClass: "flex flex-col" },
        [
          _c("or-skeleton-rect", {
            attrs: { width: _vm.width, height: _vm.height },
          }),
          _vm._v(" "),
          _c("or-skeleton-rect", {
            attrs: { width: _vm.width, height: _vm.height },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col gap-sm grow" },
        [
          _c("or-skeleton-rect", { attrs: { height: _vm.height } }),
          _vm._v(" "),
          _c("or-skeleton-rect", { attrs: { height: _vm.height } }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }